import { Box, Typography } from "@mui/material";
import { ReactElement } from "react";
import CabinetPage from "../../components/Common/CabinetPage";
import MeetingLogContainer from '../../components/Schedule/MeetingLog';
import colors from "../../colors";
import CreateMeetingButton from "../../components/Schedule/CreateMeetingButton/CreateMeetingButton";
import { isLargeFormatDevice } from "../../utils/screenSizeUtils";


const PollResultsList = (): ReactElement => {
  return (
    <CabinetPage
      pageName={'Meetings'}
      headerContent={<Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          paddingLeft: 2
        }}>
        <Typography variant="h1">
          Poll Results
        </Typography>
        {isLargeFormatDevice() && (
          <CreateMeetingButton buttonTitle="Create" />
        )}
      </Box>
      }
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          padding: 5,
          paddingTop: 4
        }}>
        <Typography variant="h2" color={colors.black600} sx={{
          fontWeight: "regular"
        }}>
          See responses to your Polls or make changes to them.
        </Typography>
        <MeetingLogContainer polls />
      </Box>
    </CabinetPage>
  );
};

export default PollResultsList;
